import { Apollo, gql } from 'apollo-angular';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { BasePaymentService } from '../../http/base-payment.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { PaymentList, PaymentMethod, PaymentMethodCMS, PaymentsCountry, WithdrawalMethod, WithdrawalMethods } from './methods.models';
import { PAYMENT_LIST, WITHDRAWAL_API } from '../../http/base-http.service';


import { catchError, distinctUntilChanged, exhaustMap, map, share, switchMap, take } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { HOST_NAME } from 'src/app/global.tokens';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { InitialDataService } from '../../page/initial-data.service';
import { LoginStatusService } from '../../auth/login/login-status.service';
import { PaymentIqService } from './paymentiq.service';
import { UserInfo } from '../../auth/login/login.models';

export const PAYMENT_METHOD_PROVIDER_BACKOFFICE = "backoffice";
export const PAYMENT_METHOD_PROVIDER_PAYMENTIQ = "paymentiq";
export const PAYMENT_METHOD_PROVIDER_ARI = "ari";

const query = gql`query PaymentMethodList($locale: Locale!, $userCountry: [Countries!]){
    paymentsCountry(first:100,where: {OR:[{country_contains_some: $userCountry}, {name: "default"}]}){
      name
      paymentMethods(locales: [$locale, en]) {
        name
        externalId
              externalNameId
              paymentIqToken
        paymentIqAdditionalFields
        externalServiceId
        thumbnail {
          url
        }
        thumbnailNew {
          url
        }
        thumbnailMobile {
          url
        }
        displayName
        openNewTab
        paymentMethodProvider
        description{
          html
        }
        addPaymentIqHostedFields
        minimalPaymentTemplates{
          overrideMinimalDeposit{
              key
              valuesCurrencies
          }
        }
        addPraxisHpf
        paymentReplacement{
          name
          weight
          paymentMethod{
            name
            externalId
          }
        }
      }
    }
  }
  `

const withdrawalQuery = gql`query WithdrawalMethodList($locale: Locale!){
  withdrawalMethods(locales: [$locale, en]) {
    name
    externalId
    displayName
    thumbnail:thumbnailNew {
      url
    }
    thumbnailNew {
      url
    }
    paymentMethodProvider
    externalNameId
    externalServiceId
    paymentIqAdditionalFields
    allowAddNewAccount
    description{
      html
    }
    }
  }
  `

function getWeightedRandomItem(items) {
  const weights = items.reduce((acc, item, i) => {
    acc.push(item.weight + (acc[i - 1] ?? 0));
    return acc;
  }, []);
  const random = Math.random() * weights.at(-1);
  return items[weights.findIndex((weight) => weight > random)];
}

const mockObj: PaymentList = [{ "id": 74, "name": "PAYMENT VOUCHER", "limits": { "maximum": 2500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-07-20T09:29:27Z", "no_form": false, "require_currency_exchange": true, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 121, "name": "REVOLUT", "limits": { "maximum": 2500, "minimum": 20, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-06-20T09:31:56Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 17, "name": "SOFORT", "limits": { "maximum": 500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-06-20T09:29:37Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 19, "name": "GIROPAY", "limits": { "maximum": 2500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-06-17T14:56:31Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 105, "name": "MIFINITY EWALLET", "limits": { "maximum": 2500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-06-17T09:40:00Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 65, "name": "JETON WALLET", "limits": { "maximum": 2500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-05-16T14:33:41Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": ["HUF", "JPY"] }, { "id": 100, "name": "INTERKASSA CARD MASTERCARD", "limits": { "maximum": 800, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-03-06T09:29:14Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 92, "name": "FINRAX", "limits": { "maximum": 2500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": "2022-01-25T14:19:39Z", "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 89, "name": "VOLT", "limits": { "maximum": 2500, "minimum": 20, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": null, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": null, "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }, { "id": 6, "name": "NETELLER", "limits": { "maximum": 2500, "minimum": 10, "currency_name": "EUR" }, "discriminate_withdraw_accept": false, "amounts_select": [{ "label": "25 EUR", "value": 25 }, { "label": "50 EUR", "value": 50 }, { "label": "100 EUR", "value": 100 }, { "label": "200 EUR", "value": 200 }], "sort_order": 7, "visible_on": ["web", "terminal", "mobile", "mobile-app", "PWA", "android", "ios"], "last_used": null, "no_form": false, "require_currency_exchange": false, "deposit_no_amount": false, "disable_decimal_for_currencies": [] }]

@Injectable({
  providedIn: 'root'
})
export class PaymentListService extends BasePaymentService {

  constructor(private apollo: Apollo, http: HttpClient,
    cookie: CookieService,
    private loginStatusService: LoginStatusService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(HOST_NAME) public hostName,
    private initialDataService: InitialDataService,
    private paymentIqService: PaymentIqService,

    private sanitizer: DomSanitizer) { super(http, cookie, locale, hostName) }


  private store = new BehaviorSubject<PaymentMethod[]>([]);

  private updatePaymentFields(boMethod: PaymentMethod, cmsResp: PaymentMethodCMS[], paymentProvider: string[], userState: UserInfo) {

    const filterPaymentIQ = (cmsMethod: PaymentMethodCMS): boolean => {
      if (cmsMethod.paymentMethodProvider !== PAYMENT_METHOD_PROVIDER_PAYMENTIQ) return false;
      let result = boMethod.provider === cmsMethod.externalNameId
      if (!!cmsMethod.externalServiceId) {
        result = result && boMethod.service === cmsMethod.externalServiceId
      }
      return result
    }
    const cmsMethod = cmsResp.find(cmsMethod => (!!cmsMethod && (boMethod.id === cmsMethod?.externalId || filterPaymentIQ(cmsMethod)) && paymentProvider.includes(cmsMethod.paymentMethodProvider)));
    if (!cmsMethod) return null;
    if (!!cmsMethod.displayName) boMethod.name = cmsMethod.displayName;
    if (!!cmsMethod.addPaymentIqHostedFields) boMethod.addPaymentIqHostedFields = cmsMethod.addPaymentIqHostedFields;
    if (!!cmsMethod.description) boMethod.description = this.sanitizer.bypassSecurityTrustHtml(cmsMethod.description.html);

    const affiliateId = userState.fullInfo.affiliate_id;
    if (!!affiliateId) {
      const valuesCurrencies = cmsMethod.minimalPaymentTemplates?.overrideMinimalDeposit?.find(item => item.key === affiliateId.toString())?.valuesCurrencies
      const overrideMinimumCurrencyValue = !!valuesCurrencies ? valuesCurrencies[userState.currency.toUpperCase()] : null;

      if (!!overrideMinimumCurrencyValue) {
        boMethod.limits.minimum = overrideMinimumCurrencyValue;
      }
    }

    boMethod.thumbnail = cmsMethod.thumbnailNew
    boMethod.thumbnailMobile = cmsMethod.thumbnailMobile
    boMethod.openNewTab = cmsMethod.openNewTab
    boMethod.systemName = cmsMethod.name
    boMethod.paymentMethodProvider = cmsMethod.paymentMethodProvider;
    boMethod.paymentIqAdditionalFields = cmsMethod.paymentIqAdditionalFields;
    boMethod.addPraxisHpf = cmsMethod.addPraxisHpf;
    return boMethod;
  }

  updateStore(country: string) {
    return this.loginStatusService.getLoginStatus(false).pipe(
      take(1),
      distinctUntilChanged(),
      // map(userState => !!userState?.fullInfo?.has_deposit),
      exhaustMap(userState => {
        return this.initialDataService.fetchData().pipe(
          share(),
          take(1),
          switchMap(data => {
            let queryCountry = data.countries.includes(country.toLowerCase()) ? country.toLowerCase() : 'default';

            return this.apollo
              .watchQuery<PaymentsCountry>({
                query: query,
                variables: {
                  userCountry: [queryCountry],
                  locale: this.locale,
                }
              })
              .valueChanges.pipe(
                take(1),
                map(resp => {
                  let paymentCountries = resp.data.paymentsCountry;
                  if (paymentCountries.length > 1) {
                    paymentCountries = paymentCountries.filter((paymentCountry) => paymentCountry.name !== 'default')
                  }
                  const replaceMethodPlace = () => {
                    const methodsList = paymentCountries[0]?.paymentMethods;
                    const result = [...methodsList]
                    let index = 0;
                    methodsList.forEach(element => {
                      if (!!element.paymentReplacement && element.paymentReplacement.length > 0) {
                        const weightSum = element.paymentReplacement.reduce((partialSum, a) => partialSum + a.weight, 0);
                        const paymentReplacement = getWeightedRandomItem([{ paymentNethod: null, weight: 100 - weightSum }, ...element.paymentReplacement])
                        if (paymentReplacement.paymentMethod) {
                          const methodIndex = methodsList.findIndex(item => item.externalId === paymentReplacement.paymentMethod.externalId);
                          [result[index], result[methodIndex]] = [result[methodIndex], result[index]];
                        }

                      }
                      index++;
                    });
                    return result;
                  }
                  const result = replaceMethodPlace();
                  return result;
                }),
                // share(),
                switchMap(cmsResp => {
                  return combineLatest({
                    boMethods: this.get<PaymentMethod[]>(PAYMENT_LIST).pipe(take(1), catchError(() => of([]))),
                    paymentIqMethods: environment.enablePaymentIQ ? this.paymentIqService.getPaymentMethods().pipe(take(1), catchError(() => of(null))) : of(null)
                  }).pipe(
                    map(methodsResp => {
                      let methods: PaymentMethod[] = [];
                      const boMethods = methodsResp.boMethods;
                      for (let boMethod of boMethods) {
                        const updatedMethod = this.updatePaymentFields(boMethod, cmsResp, [PAYMENT_METHOD_PROVIDER_BACKOFFICE, PAYMENT_METHOD_PROVIDER_ARI], userState)
                        if (!!updatedMethod) methods.push(updatedMethod);

                      }
                      const paymentIqMethods = methodsResp?.paymentIqMethods?.methods || [];
                      for (let method of paymentIqMethods) {
                        const paymentMethod = {
                          id: method.providerType, name: method.providerType, provider: method.providerType,
                          service: method.service,
                          limits: {
                            maximum: +method.limit.max,
                            minimum: +method.limit.min,
                          },
                          paymentIqAccounts: method.accounts.map(account => {
                            return {
                              accountId: account.accountId,
                              name: account.maskedAccount,
                            }
                          }),
                        } as PaymentMethod;
                        const updatedMethod = this.updatePaymentFields(paymentMethod, cmsResp, [PAYMENT_METHOD_PROVIDER_PAYMENTIQ], userState)
                        if (!!updatedMethod) {
                          methods.push(updatedMethod);
                        }

                      }
                      return methods;
                    }),
                    map(arr => {
                      let arrCopy = [...arr];
                      let sortedMethods = arrCopy.sort((a, b) => {
                        // console.log(a.name, "vs", b.name, a.id, b.id, cmsResp.findIndex(cmsMethod => a.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ ? a.id === cmsMethod.externalNameId : a.id === cmsMethod.externalId), cmsResp.findIndex(cmsMethod => b.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ ? b.id === cmsMethod.externalNameId : b.id === cmsMethod.externalId))
                        return cmsResp.findIndex(cmsMethod => {
                          if (a.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ) {
                            return a.id === cmsMethod.externalNameId && ((!!cmsMethod.externalServiceId && a.service === cmsMethod.externalServiceId) || !cmsMethod.externalServiceId)
                          }
                          else {
                            return a.id === cmsMethod.externalId;
                          }
                        })
                          - cmsResp.findIndex(cmsMethod => {
                            if (b.paymentMethodProvider === PAYMENT_METHOD_PROVIDER_PAYMENTIQ) {
                              return b.id === cmsMethod.externalNameId && ((!!cmsMethod.externalServiceId && b.service === cmsMethod.externalServiceId) || !cmsMethod.externalServiceId)
                            }
                            else {
                              return b.id === cmsMethod.externalId;
                            }
                          }
                          )
                      })
                      if (!!userState?.fullInfo?.has_deposit) {
                        const firstMethodIndex = sortedMethods.findIndex(elem => arr[0].id === elem.id);
                        // if (firstMethodIndex > 0 && firstMethodIndex < sortedMethods.length) {
                        //   const elem = sortedMethods.splice(firstMethodIndex, 1)[0];
                        //   sortedMethods.unshift(elem);
                        // }
                      }



                      return sortedMethods;
                    }
                    ),
                  )
                })
              )
          })
        )
      }))


  }

  fetchPayment(country: string): Observable<PaymentMethod[]> {
    if (this.store.value.length === 0) {
      return this.updateStore(country).pipe(switchMap(resp => {
        this.store.next(resp);
        console.log("store", this.store.value);
        return this.store.asObservable();
      }
      ))

    }
    else {
      return this.store.asObservable();
    }
  }

  private updateWithdrawalFields(boMethod: WithdrawalMethod, cmsResp: PaymentMethodCMS[], paymentProvider: string) {

    const filterPaymentIQ = (cmsMethod: PaymentMethodCMS): boolean => {
      if (cmsMethod.paymentMethodProvider !== PAYMENT_METHOD_PROVIDER_PAYMENTIQ) return false;
      let result = boMethod.provider === cmsMethod.externalNameId
      if (!!cmsMethod.externalServiceId) {
        result = result && boMethod.service === cmsMethod.externalServiceId
      }
      return result
    }
    const cmsMethod = cmsResp.find(cmsMethod => (boMethod.pk === cmsMethod.externalId || filterPaymentIQ(cmsMethod)) && cmsMethod.paymentMethodProvider === paymentProvider);
    if (!cmsMethod) return null;
    if (!!cmsMethod.displayName) boMethod.displayName = cmsMethod.displayName;
    boMethod.thumbnail = cmsMethod.thumbnailNew
    if (!!cmsMethod.description) boMethod.description = this.sanitizer.bypassSecurityTrustHtml(cmsMethod.description.html);
    boMethod.paymentMethodProvider = cmsMethod.paymentMethodProvider;
    boMethod.allowAddNewAccount = cmsMethod.allowAddNewAccount;
    boMethod.paymentIqAdditionalFields = cmsMethod.paymentIqAdditionalFields;
    return boMethod;
  }

  fetchWithdrawals() {
    return this.loginStatusService.getLoginPartialStatus().pipe(
      take(1),
      distinctUntilChanged(),
      exhaustMap(() => {
        return this.apollo
          .watchQuery<WithdrawalMethods>({
            query: withdrawalQuery,
            variables: {
              locale: this.locale
            }
          })
          .valueChanges.pipe(
            take(1),
            map(resp => resp.data.withdrawalMethods),
            switchMap(cmsResp => {
              return combineLatest({
                paymentIqMethods: environment.enablePaymentIQ ? this.paymentIqService.getWithdrawalMethods().pipe(take(1), catchError(() => of(null))) : of(null),
                // paymentIqMethods: of({ methods: [] }),
                boMethods: this.get<WithdrawalMethod[]>(WITHDRAWAL_API)
              })
                .pipe(
                  // filter(methodsResp => cmsResp.filter(cmsMethod => boMethod.pk === cmsMethod.externalId).length > 0),
                  map(methodsResp => {
                    let methods: WithdrawalMethod[] = [];
                    const boMethods = methodsResp.boMethods;
                    for (let boMethod of boMethods) {
                      const updatedMethod = this.updateWithdrawalFields(boMethod, cmsResp, PAYMENT_METHOD_PROVIDER_BACKOFFICE)
                      if (!!updatedMethod) methods.push(updatedMethod);

                    }
                    const paymentIqMethods = methodsResp?.paymentIqMethods?.methods || [];
                    let piqIndex = 1;
                    for (let method of paymentIqMethods) {
                      const paymentMethod = {
                        pk: method.providerType, name: method.providerType, provider: method.providerType,
                        service: method.service,
                        limits: {
                          maximum: +method.limit.max,
                          minimum: +method.limit.min,
                        },
                        paymentIqAccounts: method.accounts.map(account => {
                          return {
                            accountId: account.accountId,
                            name: account.maskedAccount,
                          }
                        })
                      } as WithdrawalMethod;
                      let updatedMethod = this.updateWithdrawalFields(paymentMethod, cmsResp, PAYMENT_METHOD_PROVIDER_PAYMENTIQ)
                      if (!!updatedMethod) {
                        if (!!updatedMethod.paymentIqAdditionalFields) {
                          updatedMethod.paymentIqAdditionalFields = updatedMethod.paymentIqAdditionalFields?.map((paymentIqRes: any) => {
                            const selections = [];
                            paymentIqRes.selections?.forEach((selection: any) => {
                              if (Array.isArray(selection.subselections) && selection.subselections.length > 0) {
                                (selection.subselections as Array<any>).forEach(item => {
                                  selections.push({
                                    name: selection.name + ' ' + item,
                                    value: selection.value + ' ' + item
                                  })

                                })
                              }
                              else {
                                selections.push(selection)
                              }
                            })
                            return {
                              ...paymentIqRes,
                              selections: selections
                            };
                          })
                        }
                        methods.splice(piqIndex, 0, updatedMethod);
                        piqIndex++;
                      }

                    }
                    // const cmsMethod = cmsResp.filter(cmsMethod => boMethod.pk === cmsMethod.externalId)[0]
                    // boMethod.thumbnail = cmsMethod.thumbnailNew;
                    // let withdrawalMethod: WithdrawalMethod = boMethod;
                    // withdrawalMethod.displayName = cmsMethod.displayName;
                    return methods;
                  }),
                )
            }),
          )
      })
    )


  }
}
